import ApiService from "../../services/ApiService";
import { AxiosResponse } from "axios";
import { TestTakerDeleteData, DeleteTestTakerResponse } from "../../types/types";

export default class TestTakersDeleteService {

    static DeleteTestTaker(
        testTakerDeleteData: TestTakerDeleteData
    ): Promise<DeleteTestTakerResponse> {
        const url = `${ApiService.API_URL}reports/delete-testtakerdata`;

        return ApiService.post(url, testTakerDeleteData, true)
            .then((response: AxiosResponse<DeleteTestTakerResponse>) => response.data);
    }
}